import React from "react";
import './CardItem.css';
import blueRightIcon from "../../assets/new-images/blue-right-icon.svg";

const CardItem = ({ icon, title, subtitle, prompts = [], onPromptClick, isMobile, highlight, theme, onClick }) => {
  return (
    <div
      className={`card-item ${highlight ? 'highlighted' : ''} ${theme ? `theme-${theme}` : ''} ${onClick ? 'clickable' : ''}`}
      onClick={onClick}
    >
      <div className="card-item-header">
        <div className="card-item-icon">
          <img src={icon} alt={title} />
        </div>
        <div className="card-item-title">{title}</div>
      </div>

      {subtitle && <div className="card-item-sub-text">{subtitle}</div>}

      {prompts.length > 0 && (
        <div className="card-item-prompts">
          {prompts.map((prompt, idx) => (
            <div
              key={idx}
              className={`card-item-prompt-row ${onPromptClick ? 'clickable' : ''}`}
              onClick={() => onPromptClick?.(prompt)}
            >
              <span className="card-item-prompt-text">{prompt}</span>
              {onPromptClick && <img src={blueRightIcon} alt="go" className="card-item-chevron" />}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CardItem;